import { useMemo } from 'react'

const useTransform = (marginLeft: number, marginTop: number): string =>
  useMemo(
    (): string => `translate(${marginLeft * 2}, ${marginTop})`,
    [marginLeft, marginTop]
  )

export default useTransform
